export default "__VITE_ASSET__nOTPdHci__"